module.exports = __webpack_public_path__ + "img/Spider Monitor.5eab6d07.svg";